import { PAGE } from '@/api'

/* Define Module Name */
// const MODULE_NAME = "page/";

/* Define Action Name */
const A_GET_LANDING_PAGE_DATA = 'getLandingPageData'
const A_GET_SHOP_DATA = 'getShopData'

/* Define Getter Name */
const G_TERMS_OF_SERVICE = 'termsOfService'
const G_AGENT_TERMS_AND_CONDITIONS = 'agentTermsAndConditions'
const G_PERSONAL_DATA_POLICY = 'personalDataPolicy'
const G_AGENT_FEATURES = 'agentFeatures'
const G_PROMO_BANNERS = 'promoBanners'
const G_BEST_SELLERS = 'bestSellers'
const G_LANDING_PAGE_HOT_DEALS = 'landingPageHotDeals'
const G_LANDING_PAGE_FLASH_DEALS = 'landingPageFlashDeals'
const G_ARTICLES = 'articles'
const G_CATEGORIES = 'categories'
const G_AGENT_MIN_WITHDRAWAL_AMT = 'agent_min_withdrawal_amount'
const G_CUSTOMER_SERVICE_EMAIL = 'customerServiceEmail'

/* Define Mutation Name */
const M_SET_LANDING_PAGE_DATA = 'setLandingPageData'

const state = {
  landingPageData: {}
}

//Getters
const getters = {
  [G_TERMS_OF_SERVICE]: (state) => state.landingPageData.membertermsandconditions,
  [G_AGENT_TERMS_AND_CONDITIONS]: (state) => state.landingPageData.agenttermsandconditions,
  [G_PERSONAL_DATA_POLICY]: (state) => state.landingPageData.personaldatapolicy,
  [G_AGENT_FEATURES]: (state) => state.landingPageData.partner_details,
  [G_PROMO_BANNERS]: (state) => state.landingPageData.banner,
  [G_BEST_SELLERS]: (state) => state.landingPageData.top_pick_product_range,
  [G_LANDING_PAGE_HOT_DEALS]: (state) => state.landingPageData.hot_deals,
  [G_LANDING_PAGE_FLASH_DEALS]: (state) => state.landingPageData.flash_deals,
  [G_ARTICLES]: (state) => state.landingPageData.article,
  [G_CATEGORIES]: (state) => state.landingPageData.categories,
  [G_AGENT_MIN_WITHDRAWAL_AMT]: (state) => state.landingPageData.agent_min_withdrawal_amount,
  [G_CUSTOMER_SERVICE_EMAIL]: (state) => state.landingPageData.customer_service_email
}

// Actions
const actions = {
  async [A_GET_LANDING_PAGE_DATA]({ commit }) {
    return await PAGE.getLandingPageData().then((response) => {
      console.log('RES', response)
      commit(M_SET_LANDING_PAGE_DATA, response)
    })
  },
  async [A_GET_SHOP_DATA](_, data) {
    return await PAGE.getShopData(data)
  }
}

// Mutations
const mutations = {
  [M_SET_LANDING_PAGE_DATA]: (state, landingData) => {
    state.landingPageData = landingData
  }
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}
